<template lang="html">
  <div class="pontok">
    <v-row justify="center" no-gutters>
      <v-col cols="2" v-for="pont in pontok" :key="pont">
        <transition name="fade" mode='out-in' appear>
          <Maci />
        </transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Maci from '@/components/Kids/Maci.vue'
export default {
  props: ['pontok'],
  components: {
    Maci,
  }
}
</script>

<style lang="scss" scoped>
.pontok .row{
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  min-height: 60px;
}
</style>
